import { render, staticRenderFns } from "./HotTabItem.vue?vue&type=template&id=5e5ae3d5&"
import script from "./HotTabItem.vue?vue&type=script&lang=js&"
export * from "./HotTabItem.vue?vue&type=script&lang=js&"
import style0 from "./HotTabItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e5ae3d5')) {
      api.createRecord('5e5ae3d5', component.options)
    } else {
      api.reload('5e5ae3d5', component.options)
    }
    module.hot.accept("./HotTabItem.vue?vue&type=template&id=5e5ae3d5&", function () {
      api.rerender('5e5ae3d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/hotsugg/components/HotTabItem.vue"
export default component.exports